import styled from "@emotion/styled";
import { Header, Icon, Message, Table } from "semantic-ui-react";
import { DateTime } from "luxon";

type LinkedLrwSessionDto = {
  id: number;
  date: string;
  startTime: string;
  endTime: string;
  venue: string;
};

type Props = {
  linkedLrwSessions?: LinkedLrwSessionDto[];
};

export const formatTimeOnly = (time: string) => {
  return DateTime.fromISO(time, { setZone: true }).toFormat('HH:mm');
};

export const LinkedLrwSessions = ({ linkedLrwSessions }: Props) => {
  const noContent = (
    <Message color="blue">
      <Icon name='info circle'/>
      No Listening, Reading, Writing sessions are currently linked to this speaking session
    </Message>
  );

  const tableContent = (
    <S.NoBorderContentFitTable basic="very" compact>
      <Table.Body>
        {linkedLrwSessions?.map((session, index) => (
          <Table.Row key={session.id || index}>
            <Table.Cell>
              <Icon name="calendar alternate outline" /> {session.date}
            </Table.Cell>
            <Table.Cell>
              <Icon name="clock outline" /> {formatTimeOnly(session.startTime)} - {formatTimeOnly(session.endTime)}
            </Table.Cell>
            <Table.Cell>
              <Icon name="building outline" /> {session.venue}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </S.NoBorderContentFitTable>
  );

  return (
    <>
      <Header as="h4">Linked LRW Sessions</Header>
      {!linkedLrwSessions || linkedLrwSessions.length === 0 ? noContent : tableContent}
    </>
  );
};

const S = {
  NoBorderContentFitTable: styled(Table)`
    width: auto !important;
    
    tr {
      border: none !important;
      border-bottom: none !important;
    }
    
    th, td {
      border: none !important;
      border-left: none !important;
      border-right: none !important;
      border-top: none !important;
      border-bottom: none !important;
    }
  `
};